import { blinkConstants } from '@thoughtspot/blink-constants';
import { useTranslation } from '@thoughtspot/i18n';
import { Button } from '@thoughtspot/radiant-react/widgets/button';
import { Divider } from '@thoughtspot/radiant-react/widgets/divider';
import { IconID } from '@thoughtspot/radiant-react/widgets/icon';
import { Menu } from '@thoughtspot/radiant-react/widgets/menu';
import { Popover } from '@thoughtspot/radiant-react/widgets/popover';
import { Typography } from '@thoughtspot/radiant-react/widgets/typography';
import React, { useEffect, useRef, useState } from 'react';
import styles from './help-menu.module.scss';
export var HelpMenuTestIDs;
(function (HelpMenuTestIDs) {
    HelpMenuTestIDs["HelpMenuButton"] = "help-menu-button";
    HelpMenuTestIDs["HelpMenuPopover"] = "help-menu-popover";
})(HelpMenuTestIDs || (HelpMenuTestIDs = {}));
const helpWidgetIcon = {
    BLINK_HOW_SEARCH_WORKS: 'VIDEO',
    BLINK_KEYWORDS: 'KEY',
    BLINK_RELEASE_NOTES: 'NOTE',
    BLINK_DOCUMENTATION: 'DOCUMENTATION',
    BLINK_DOWNLOADS: 'DOWNLOAD',
    BLINK_DEFAULT_ICON: 'NOTE',
};
export const HelpMenu = ({ getHelpConfig, getBaseReleaseVersion, getReleaseVersion, isPendoHelpEnabled, sendMixpanelEvent, getOnlineDocUrl, isSaaSCluster, }) => {
    const { t } = useTranslation();
    const openExternalUrlInNewTab = (url) => {
        window.open(url, '_blank');
    };
    const [showHelpMenu, setShowHelpMenu] = useState(false);
    const [helpConfigList, setHelpConfigList] = useState([]);
    const helpPopoverRef = useRef(null);
    const helpConfigs = getHelpConfig() || [];
    useEffect(() => {
        const docsVersion = getBaseReleaseVersion();
        const docsUrl = getOnlineDocUrl();
        const newConfig = helpConfigs.filter((item) => {
            if (isSaaSCluster()) {
                return item.id !== 'BLINK_DOWNLOADS';
            }
            return true;
        });
        newConfig.forEach((helpItem) => {
            const { url } = helpItem;
            helpItem.url = url
                .replace('{versionNameForLink}', docsVersion)
                .replace('{docsUrl}', docsUrl);
        });
        setHelpConfigList(newConfig);
    }, []);
    const getHelpWidgetIcon = (id) => {
        return IconID[helpWidgetIcon[id]];
    };
    const openResourceCenter = () => {
        sendMixpanelEvent();
    };
    const toggleHelpMenu = () => {
        setShowHelpMenu(show => !show);
        sendMixpanelEvent();
    };
    useEffect(() => {
        if (showHelpMenu) {
            document.querySelector('#BLINK_KEYWORDS')?.focus();
        }
        else {
            document.querySelector(`#${HelpMenuTestIDs.HelpMenuButton}`)?.children[0]?.focus();
        }
    }, [showHelpMenu]);
    const selectContent = () => {
        return (React.createElement("div", { "data-testid": HelpMenuTestIDs.HelpMenuPopover },
            React.createElement(Menu, { id: "Menu", show: showHelpMenu },
                React.createElement(Menu.Group, null, helpConfigList.map(help => (React.createElement(Menu.Item, { label: t(help.title), id: t(help.id), key: help.id, iconName: getHelpWidgetIcon(help.id), onSelect: () => {
                        openExternalUrlInNewTab(help.url);
                    } })))),
                React.createElement(Menu.Group, { showSeparator: false },
                    React.createElement(Menu.Item, { label: t('Ask_community'), id: "COMMUNITY_ID", iconName: IconID.COMMUNITY, onSelect: () => {
                            openExternalUrlInNewTab(blinkConstants.help.COMMUNITY);
                        } }),
                    React.createElement(Menu.Item, { label: t('Submit_case'), id: "SUBMIT_CASE_ID", iconName: IconID.CASE, onSelect: () => {
                            openExternalUrlInNewTab(blinkConstants.help.CONTACT_SUPPORT);
                        } }),
                    React.createElement(Divider, null),
                    React.createElement(Typography, { variant: "p", className: styles.version }, `${t('Version')} ${getReleaseVersion()}`)))));
    };
    React.useEffect(() => {
        if (!showHelpMenu) {
            document?.querySelector(`#${HelpMenuTestIDs.HelpMenuButton} > button`)?.focus();
        }
    }, [showHelpMenu]);
    return isPendoHelpEnabled ? (React.createElement("div", { id: "resource-center-div" },
        React.createElement(Button, { onClick: openResourceCenter, icon: IconID.QUESTION_MARK, type: "secondary", "data-testid": HelpMenuTestIDs.HelpMenuButton }))) : (React.createElement(React.Fragment, null,
        React.createElement("div", { ref: helpPopoverRef },
            React.createElement(Button, { onClick: toggleHelpMenu, icon: IconID.QUESTION_MARK, type: "secondary", "data-testid": HelpMenuTestIDs.HelpMenuButton, id: HelpMenuTestIDs.HelpMenuButton, "aria-expanded": !!showHelpMenu })),
        React.createElement(Popover, { className: styles.profilePopover, bottomOffset: 8, targetRef: helpPopoverRef, content: selectContent(), isVisible: showHelpMenu, align: "bottom-start", appendToBody: true, onClickOutside: () => {
                setShowHelpMenu(false);
            }, onEscape: (e) => {
                setShowHelpMenu(false);
            } })));
};
//# sourceMappingURL=help-menu.js.map